import React, { useContext, useEffect, useState } from "react";
import { Text } from "rizzui/typography";
import { Radio } from "rizzui/radio";
import { useModal } from "../hooks/useModal";
import { ActionIcon } from "rizzui/action-icon";
import axios from "axios";
import { useNavigate } from "react-router";
import { AuthContext } from "../context/authContext";
import { baseUrl } from "../modules/account/login";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNotifcication } from "../hooks/useNotification";
import { inputClassName, labelClassName } from "../modules/projects/new/first";
import { Input } from "rizzui/input";
import SearchIcon from "../assets/search";
import { useLocation } from "react-router";

export default function ReviewContact({
  leads,
  newCampaign,
  overrideKey,
  leads_csv,
}) {
  const { closeModal } = useModal();
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);
  const [allLeads, setAllLeads] = useState(leads);
  const [override, setOverride] = useState<any>([]);
  const queryClient = useQueryClient();
  const { openNotification } = useNotifcication();
  const [option, setOption] = useState("");
  const [error, setError] = useState("");
  const location = useLocation();

  useEffect(() => {
    option && setError("");
    option === "all_enter" ? setOverride(allLeads) : setOverride([]);
  }, [option]);

  const handleCSVEntry = () => {
    const formData = new FormData();
    formData.append("leads_csv", leads_csv);
    formData.append("campaign_id", newCampaign);
    formData.append("override_key", overrideKey);
    formData.append("allowed_values", JSON.stringify(override));
    return axios
      .post(`${baseUrl}/leads/override_leads_upload`, formData, {
        headers: { Authorization: AuthStr },
      })
      .then((response) => {
        if (response?.data?.success) {
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey[0] === "leads",
          });
          queryClient.invalidateQueries({
            queryKey: [newCampaign, "campaign_analytics", token],
          });
          openNotification({
            status: "success",
            message: "Leads Added",
          });
          closeModal();
          location?.pathname === "/campaigns/new" &&
            setTimeout(() => navigate("/campaigns"), 1000);
        }
        return response;
      })
      .catch((e) => {
        if (e?.response?.data?.message === "Session expired")
          navigate("/account/logout");

        return Promise.reject(
          new Error(e?.response?.data?.message ?? "Something went wrong")
        );
      });
  };

  const {
    mutate: overrideCSVUpload,
    error: entryError,
    isPending: entryLoading,
  } = useMutation({
    mutationFn: handleCSVEntry,
    retry: 0,
  });

  const submit = () => {
    option
      ? option !== "non_enter"
        ? overrideCSVUpload()
        : closeModal()
      : setError("Select an option");
  };

  const filterLeads = (filter) => {
    if (filter.length > 1) {
      const currentLeads = allLeads;
      const newLeads = currentLeads.filter((lead) =>
        Object.values(lead).some((value) =>
          String(value).toLowerCase().includes(filter.toLowerCase())
        )
      );
      setAllLeads(newLeads);
    } else setAllLeads(leads);
  };
  const checkChecked = (lead) => {
    return override.some(
      (value) => JSON.stringify(value) === JSON.stringify(lead)
    );
  };

  const toggleCheck = (lead) => {
    setOverride((prevOverride) => {
      const exists = prevOverride.some(
        (value) => JSON.stringify(value) === JSON.stringify(lead)
      );
      return exists
        ? prevOverride.filter(
            (value) => JSON.stringify(value) !== JSON.stringify(lead)
          )
        : [...prevOverride, lead];
    });
  };

  return (
    <div className="mx-auto overflow-y-auto max-h-[715px] min-h-[342px] h-auto customBar bg-background dark:bg-[#2A2C30] border-muted md:w-[471px] w-[96%] flex flex-col gap-[20px] p-[32px] rounded-[8px]">
      <button
        className="absolute top-4 right-4 p-1 rounded-lg z-10 text-gray-400 bg-transparent hover:text-gray-600 dark:hover:text-gray-300"
        onClick={closeModal}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="size-[18px]"
        >
          <path
            fillRule="evenodd"
            d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      <div className="flex flex-col gap-[41px]">
        <div className="flex flex-col gap-[41px]">
          <div className="flex flex-col gap-[8px]">
            <p className="font-ibmPlexSerif font-[600] text-primary-dark text-[18px]">
              Some contacts are in other campaigns
            </p>
            <p className="font-switzer text-[#758599] font-[400] text-[14px]">
              Select an option to proceed
            </p>
          </div>
          <div className="flex flex-col gap-[16px]">
            <Radio
              label="Overwrite contacts to new campaign"
              labelClassName={labelClassName}
              name="option"
              value="all_enter"
              onChange={(e) => e.target.checked && setOption("all_enter")}
            />
            <Radio
              label="Overwrite contacts to new campaign but exclude some contacts"
              labelClassName={labelClassName}
              name="option"
              value="some_enter"
              onChange={(e) => e.target.checked && setOption("some_enter")}
            />
            <Radio
              label="Contacts should remain in the old campaign"
              labelClassName={labelClassName}
              name="option"
              value="non_enter"
              onChange={(e) => e.target.checked && setOption("non_enter")}
            />
            {error && (
              <Text className="font-[400] -mt-[8px] text-[12px] text-red font-switzer">
                {error}
              </Text>
            )}
          </div>
          {option === "some_enter" && (
            <div className="flex flex-col gap-[9px] h-[331px]">
              <Text className="font-ibmPlexSerif font-[500] text-[12px] text-[#758599]">
                Select contacts to exclude from the overwrite
              </Text>
              <div className="max-h-[307px] h-auto border-dashed border-[1px] border-[#758599] rounded-[4px] font-switzer text-[12px] text-[#758599] py-[18.5px]">
                <div className="flex flex-col gap-[19px] h-[280px]">
                  <Input
                    inputClassName={inputClassName}
                    placeholder="Search here"
                    prefix={<SearchIcon />}
                    className="mx-[16px]"
                    onChange={(e) => filterLeads(e.target.value)}
                  />
                  <Text>
                    <input
                      type="checkbox"
                      className="!ring-0 [&:checked]:bg-black [&:checked:focus]:!bg-black [&:checked:hover]:!bg-black  [&:checked:hover]:!ring-black ml-[16px] rounded-[4px]"
                      aria-label="Select all"
                      checked={
                        allLeads.length > 0 &&
                        allLeads.length === override.length
                      }
                      onChange={() => {
                        override === allLeads
                          ? setOverride([])
                          : setOverride(allLeads);
                      }}
                    />
                    <span className="ml-[4px]">Select all</span>
                  </Text>
                  <div className="customBar max-h-[272px] h-auto overflow-y-auto flex flex-col gap-[19px] px-[16px]">
                    {allLeads.map((lead: any, index) => {
                      return (
                        <>
                          <div
                            key={index}
                            className="grid grid-cols-2 gap-[8px]"
                          >
                            <div className="flex gap-[4px] items-center">
                              <input
                                type="checkbox"
                                className="!ring-0 [&:checked]:bg-black [&:checked:focus]:!bg-black [&:checked:hover]:!bg-black  [&:checked:hover]:!ring-black rounded-[4px]"
                                name={lead}
                                checked={checkChecked(lead)}
                                onChange={() => toggleCheck(lead)}
                              />
                              <p className="overflow-hidden overflow-ellipsis whitespace-nowrap">
                                {`${lead["First Name"]}  ${lead["Last Name"]}`}
                              </p>
                            </div>

                            <p className="overflow-hidden overflow-ellipsis whitespace-nowrap justify-self-end">
                              {lead.Phone}
                            </p>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="w-[203px] flex justify-between place-self-end">
            <ActionIcon
              className="text-black dark:!bg-muted dark:text-[#758599] !bg-[#F2F2F2] w-[92px] h-[35px] font-switzer text-[12px] font-[400] rounded-[4px]"
              onClick={closeModal}
            >
              Cancel
            </ActionIcon>
            <ActionIcon
              className="!text-background !bg-btn w-[92px] h-[35px] font-switzer text-[12px] font-[400] rounded-[4px]"
              variant="text"
              isLoading={entryLoading}
              onClick={submit}
            >
              Submit
            </ActionIcon>
          </div>

          {entryError && (
            <Text className="font-[400] text-[12px] text-red font-switzer">
              {entryError.message}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
}
